import { cn } from "@/lib/cn";
import type { BadgeAccent, BadgeKind } from "@/types";

const accentClasses: Record<BadgeAccent, string> = {
  "leaf-green": "bg-leaf-green-ink text-white",
  "royal-blue": "bg-royal-blue text-white",
  "calm-orange": "bg-calm-orange-ink text-white",
  "happy-red": "bg-happy-red-ink text-white",
  "healthy-blue": "bg-healthy-blue text-white",
};

const defaultAccentFor: Record<BadgeKind, BadgeAccent> = {
  "BEST SELLER": "leaf-green",
  SALE: "happy-red",
  NEW: "healthy-blue",
  DAYTIME: "leaf-green",
  NIGHTTIME: "royal-blue",
  CLOSEOUT: "happy-red",
  VET: "healthy-blue",
};

export function Badge({
  kind,
  accent,
  className,
}: {
  kind: BadgeKind;
  accent?: BadgeAccent;
  className?: string;
}) {
  const a = accent ?? defaultAccentFor[kind];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill px-3 py-1 text-[10px] font-condensed font-bold uppercase tracking-wider",
        accentClasses[a],
        className,
      )}
    >
      {kind}
    </span>
  );
}
